import React, { Component } from "react";
import "./styles.css";
import Icon from "../../prefabs/icon/view";
import CircleIcon from "../../prefabs/circle-icon/view";

class RadioToggle extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClickBtn = this.onClickBtn.bind(this);
    this.handleInfoClick = this.handleInfoClick.bind(this);
  }

  // ===============================================================================================
  onClickBtn(value) {
    this.props.handleChange(value);
  }

  // ===============================================================================================
  handleInfoClick(value) {
    this.props.handleInfoPopup(value);
  }

  // ===============================================================================================
  render() {
    return (
      <div className="radio-toggle">
        <div className="radio-toggle__option radio-toggle__option__hosted">
          <div className="radio-toggle__info">
            <button 
                className={`radio-toggle__info__btn`}
                onClick={() => this.handleInfoClick('hosted')}
              >
              <Icon
                type="info"
                className="radio-toggle__info-icon"
              />
            </button>
          </div>
          
          <div className="radio-toggle__image">
            <div className="parties-host">
              <img className="parties-host-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/parties-host.svg"  alt="host"/>
            </div>
          </div>
          <button 
            className={`radio-toggle__btn ${this.props.eventType === 'hosted' ? 'radio-toggle__btn--checked' : ''}`}
            onClick={() => this.onClickBtn('hosted')}
          >
            {/* <Icon type={this.props.eventType === 'hosted' ? "radio-yb" : "radio-b"}/> */}
            <CircleIcon
                checked={this.props.eventType === 'hosted'}
                type={(this.props.eventType === 'hosted') ? "checkmark-b" : ""}
              />
            <span className="radio-toggle__label">Book a hosted birthday party package</span>
          </button>
        </div>
        <div className="radio-toggle__option radio-toggle__option__no_host">
          <div className="radio-toggle__info">
            <button 
                className={`radio-toggle__info__btn`}
                onClick={() => this.handleInfoClick('no-host')}
              >
              <Icon
                type="info"
                className="radio-toggle__info-icon"
              />
            </button>
          </div>
          <div className="radio-toggle__image">
            <div className="parties-space">
              <img className="parties-space-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/event-space.svg"  alt="space"/>
            </div>
          </div>
          <button 
            className={`radio-toggle__btn ${this.props.eventType === 'no-host' ? 'radio-toggle__btn--checked' : ''}`}
            onClick={() => this.onClickBtn('no-host')}
          >
            {/* <Icon type={this.props.eventType === 'no-host' ? "radio-yb" : "radio-b"}/> */}
            <CircleIcon
              checked={this.props.eventType === 'no-host'}
              // checked={false}
              disabled={false}
              type={(this.props.eventType === 'no-host') ? "checkmark-b" : ""}
            />
            <span className="radio-toggle__label">Book an event space</span>
          </button>
        </div>
      </div>
    );
  }
}

export default RadioToggle;